// extracted by mini-css-extract-plugin
module.exports = {"simpleLabel":"toolbarselects_simpleLabel__2ttrK","choiceBoxes":"toolbarselects_choiceBoxes__1T-8l","simpleField":"toolbarselects_simpleField__mhgQE"};